import { useMemo } from "react";
import { useSendingDomains } from "@api/sendingDomain.api";
import { useCurrentLoginProvider } from "@hooks/useCurrentLoginProvider";
import { useCurrentUserIsWorkspaceOrganizationMember } from "@hooks/useCurrentUserIsWorkspaceOrganizationMember";
import { useUserStatus } from "@hooks/useUserStatus";
import { useWorkspaceSendingEmails } from "@hooks/useWorkspaceSendingEmails";
import { useWorkspaceSendingOwner } from "@hooks/useWorkspaceSendingOwner";
import {
    getSuggestedDnsSender,
    getSuggestedGmailSender,
} from "./getSuggestedCustomSender";

export function useSuggestedCustomSender() {
    const loginProvider = useCurrentLoginProvider();
    const { data: userStatus } = useUserStatus();
    const { isOrganizationMember, isFetched: isOrganizationFetched } =
        useCurrentUserIsWorkspaceOrganizationMember();
    const owner = useWorkspaceSendingOwner();
    const { data: emails, isLoading: isLoadingEmails } =
        useWorkspaceSendingEmails();
    const { data: domains, isLoading: isLoadingDomains } =
        useSendingDomains(owner);

    const suggestion = useMemo(() => {
        if (
            !isOrganizationFetched ||
            isLoadingEmails ||
            isLoadingDomains ||
            emails === undefined ||
            domains === undefined ||
            isOrganizationMember
        ) {
            return null;
        }

        const userEmail = userStatus?.user.email;

        if (loginProvider === "google") {
            return getSuggestedGmailSender({
                userEmail,
                sendingEmails: emails,
            });
        }

        if (loginProvider === "email") {
            return getSuggestedDnsSender({
                userEmail,
                sendingEmails: emails,
                sendingDomains: domains,
            });
        }

        return null;
    }, [
        domains,
        emails,
        isLoadingDomains,
        isLoadingEmails,
        isOrganizationFetched,
        isOrganizationMember,
        loginProvider,
        userStatus?.user.email,
    ]);

    return suggestion;
}
